import React from 'react'
import { Label } from 'semantic-ui-react'
// Local
import {
  formatIcd10Code,
  displayRiskCode
} from '../../common/formatUtils'
import AddressedIcon from '../common/addressedIcon'
import { EncounterConditionDisplay } from '../../authenticated/types'
import If from '../../common/if'
import { shouldRenderReskin2025 } from '../../../constant'

/**
 * Provides a component for the clinical admin HCC condition group header title.
 *
 * @param mode View mode. Options: null or "smart". Default: null
 * @param active True if group is currently in active state
 * @param hccCode HCC Code
 * @param hccDescription HCC description
 * @param conditions Group conditions
 * @param onConditionAction Callback for condition action
 *        Arguments: action, condition
 */

type Props = {
  active: boolean
  hccCode: string
  hccDescription: string
  conditions: EncounterConditionDisplay[]
}

function ClinicalAdminConditionHccHeaderTitle(
  props: Props
): JSX.Element {
  const {
    active: isActiveProp,
    hccCode,
    hccDescription,
    conditions
  } = props
  const conditionHccTitle = () => {
    const labelColor = isActiveProp
      ? 'blue'
      : 'grey'
    const icd10Codes = conditions.filter(
      c => c.icd10CodeJson && c.icd10CodeJson.length > 0
    ).map(
      c => formatIcd10Code(c && c.icd10CodeJson && c.icd10CodeJson[0])
    ).join(', ')
    return (
      <span>
        <Label
          pointing="right"
          color={ labelColor }
        >
          { displayRiskCode(hccCode) }
        </Label>
        <span>&nbsp;</span>
        <span>
          <If isTrue={ isActiveProp }>
            <strong>
              { hccDescription }
            </strong>
          </If>
          <If isTrue={ !isActiveProp }>
            <span>
              { hccDescription }
            </span>
          </If>
        </span>
        <span>&nbsp;</span>
        <If isTrue={ icd10Codes.length > 0 }>
          (<span className="italic">
            { icd10Codes }
          </span>)
        </If>
      </span>
    )
  }
  const titleText = conditionHccTitle()

  const conditionTitle = shouldRenderReskin2025
    ? 'condition-title reskin'
    : 'condition-title'

  return (
    <div className="physician-condition-title">
      <div className="flex-title">
        <AddressedIcon conditions={ conditions } />
        <div className={ conditionTitle }>
          <If isTrue={ isActiveProp }>
            <strong>
              { titleText }
            </strong>
          </If>
          <If isTrue={ !isActiveProp }>
            { titleText }
          </If>
        </div>
      </div>
    </div>
  )
}

export default ClinicalAdminConditionHccHeaderTitle
